import * as yup from 'yup';
import '../../utils/formUtils';
import commands, { mssSubTypes } from 'dmpconnectjsapp-base/actions/config/commands';
import { apiSections } from 'dmpconnectjsapp-base/constants';
import { getAccessRightsProps } from 'dmpconnectjsapp-base/rules/accessRights';
import { getUserConfiguration } from 'dmpconnectjsapp-base/helpers/accessors';
import {
  formatSendMssOtpAuthenticatedEmail,
  formatSendMssSmtpEmail,
} from 'dmpconnectjsapp-base/actions/config/commandParamsFormatters';
import { getAction, sendMssWebEmail } from '../../actions';
import { API_TYPES } from '../../constants';

export const MssConfigSchema = yup.object({
  mssEmail: yup.string()
    .email('Ce n\'est pas une adresse email valide (exemple@domaine.com)').required('Ce champs est requis'),
  mssImapServer: yup.string().required('Ce champs est requis'),
  mssSmtpServer: yup.string().required('Ce champs est requis'),
});

export const mssFolderTypes = {
  INBOX: 'inbox',
  SENT: 'sent',
  JUNK: 'junk',
  TRASH: 'trash',
};

export const isMssPatientEmail = (emailAdress) => {
  const regexp = /^\d{15}@patient.mssante.fr$/;
  return regexp.test(emailAdress);
};

export const getMssSenderWording = (state) => {
  const { dmpconnectCPxConfiguration } = state;
  const { accessRights } = getAccessRightsProps(state);
  return getUserConfiguration(
    { s_internalId: accessRights.psId },
    'mssSenderWording',
    dmpconnectCPxConfiguration,
  );
};

export const getMssReplyTo = (state) => {
  const { dmpconnectCPxConfiguration } = state;
  const { accessRights } = getAccessRightsProps(state);
  return getUserConfiguration(
    { s_internalId: accessRights.psId },
    'mssReplyTo',
    dmpconnectCPxConfiguration,
  );
};

export function dispatchMarkMessagesAsRead(dispatch, mssEmail, messageIds, read, folderId, mssApiType) {
  if (mssApiType === mssSubTypes.IMAP) {
    messageIds.forEach(messageId => dispatch(getAction(
      commands.updateMessagesMSS,
      apiSections.MSS_UPDATE_MESSAGE,
      {
        email: mssEmail,
        messageIds: [messageId],
        operation: 'READ',
        add: read,
        folderId,
      },
      {
        subSection: messageId,
        subConfig: mssApiType,
        synchronous: true,
        contextExtra: {
          mssApiType,
          priority: true,
        },
      },
    )));
  } else {
    dispatch(getAction(
      commands.updateMessagesMSS,
      apiSections.MSS_UPDATE_MESSAGE,
      {
        email: mssEmail,
        messageIds,
        operation: read === true ? 'READ' : 'UNREAD',
        folderId,
      },
      {
        subSection: messageIds.join(','),
        subConfig: mssApiType,
        synchronous: true,
        contextExtra: {
          mssApiType,
          priority: true,
        },
      },
    ));
  }
}

export function dispatchMoveMessagesTo(dispatch, mssEmail, messageIds, sourceFolderId, destinationFolderId, mssApiType) {
  if (mssApiType === mssSubTypes.IMAP) {
    messageIds.forEach(messageId => dispatch(getAction(
      commands.moveMSSMessages,
      apiSections.MSS_MOVE_MESSAGES,
      {
        email: mssEmail,
        messageIds: [messageId],
        destinationFolderId,
        sourceFolderId,
      },
      {
        subSection: messageIds.join(','),
        subConfig: mssApiType,
        synchronous: true,
        contextExtra: {
          mssApiType,
          priority: true,
          sourceFolderId,
          destinationFolderId,
        },
      },
    )));
  } else {
    dispatch(getAction(
      commands.moveMSSMessages,
      apiSections.MSS_MOVE_MESSAGES,
      {
        email: mssEmail,
        messageIds,
        destinationFolderId,
        sourceFolderId,
      },
      {
        subSection: messageIds.join(','),
        subConfig: mssApiType,
        synchronous: true,
        contextExtra: {
          mssApiType,
          priority: true,
          sourceFolderId,
          destinationFolderId,
        },
      },
    ));
  }
}

export function dispatchDeleteMessages(dispatch, mssEmail, messageIds, folderId, mssApiType) {
  if (mssApiType === mssSubTypes.IMAP) {
    messageIds.forEach(messageId => dispatch(getAction(
      commands.deleteMssMessages,
      apiSections.MSS_DELETE_MESSAGES,
      {
        email: mssEmail,
        messageIds: [messageId],
        folderId,
      },
      {
        subSection: messageIds.join(','),
        subConfig: mssApiType,
        synchronous: true,
        contextExtra: {
          mssApiType,
          priority: true,
        },
      },
    )));
  } else {
    dispatch(getAction(
      commands.deleteMssMessages,
      apiSections.MSS_DELETE_MESSAGES,
      {
        email: mssEmail,
        messageIds,
        folderId,
      },
      {
        subSection: messageIds.join(','),
        subConfig: mssApiType,
        synchronous: true,
        contextExtra: {
          mssApiType,
          priority: true,
        },
      },
    ));
  }
}

export function getSendMssEmailAction(mssApiType, apiType, emailContent, esUser, hpAuthenticationMode) {
  let action;
  if (mssApiType === mssSubTypes.WEB) {
    action = sendMssWebEmail(
      apiType === API_TYPES.REST
        ? formatSendMssOtpAuthenticatedEmail(emailContent, {
          ...esUser,
          hpAuthenticationMode: esUser.hpAuthenticationMode || hpAuthenticationMode,
        })
        : emailContent,
      esUser,
    );
  } else if (mssApiType === mssSubTypes.IMAP) {
    action = getAction(
      commands.sendMssSmtpEmail,
      apiSections.MSS_SEND_SMTP_EMAIL,
      formatSendMssSmtpEmail({ ...emailContent, esUser }, apiType === API_TYPES.REST),
      {
        synchronous: true,
        contextExtra: { priority: true },
      },
    );
  }
  return action;
}

export const flatFolders = (folders = []) => folders.reduce((result, folder) => {
  if (folder.folders && folder.folders.length > 0) {
    return [...result, folder, ...flatFolders(folder.folders)];
  }
  return [...result, folder];
}, []);
